import React from 'react'
import PicCont from './PicCont'
import LinkWrap from './LinkWrap'
import landing from '../public/Pictures/landing-bg.png'
import h2 from '../public/Pictures/projector_h.jpg'


const OverBanner = ({ picture, children, faded, className, priority, loading  }) => {


    return <div className={`overBanner ${faded ? 'faded':''} ${className} `}>
        <div className='bannerRow'>
        <div className='picBack'>
        <PicCont  priority={priority} loading={loading} background src={picture} className={``} />
            </div>

    <div className='box'>
            {children}
            <div className='back'></div>

        </div>

        </div>
        


    </div>



}

export default OverBanner